const SERVICES = [
  {
    icon: 'ri-temp-hot-line',
    title: 'HVAC',
    description: 'Reliable HVAC installation, repair, and replacement for homes and businesses across Chicago. Year-round comfort solutions.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Plumbing',
    description: 'From leaky pipes to full system installations — done right the first time. No repeat visits, no surprise costs.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Electrical',
    description: 'Professional electrical services from panel upgrades to full buildouts. Every job meets code and keeps your property safe.',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Porches & Decks',
    description: 'Custom porches and decks built to hold up against Chicago weather for years. We add real value to your outdoor space.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Roofing & Siding',
    description: 'Installation, repair, and replacement using quality materials. We assess honestly and handle quickly.',
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Painting',
    description: 'Interior and exterior painting with clean, professional results. From prep to final coat, every surface is treated with care.',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Remodeling & Renovations',
    description: '11 years of Chicago remodeling experience. Better layouts, better finishes, better function — we manage every detail.',
  },
  {
    icon: 'ri-clipboard-line',
    title: 'Construction Management',
    description: 'We oversee every phase — planning, permitting, final walkthrough — keeping projects on schedule and on budget.',
  },
  {
    icon: 'ri-store-2-line',
    title: 'Commercial Buildouts',
    description: 'Professional buildouts for small businesses throughout Chicago and the suburbs, delivered on time and within budget.',
  },
];

export default function ServicesSection() {
  const handleScroll = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="text-red-600 text-base font-semibold tracking-widest uppercase mb-3" style={{ fontFamily: "'Inter', sans-serif" }}>
            What We Do
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" style={{ fontFamily: "'Oswald', sans-serif" }}>
            One Team. Every Trade. Zero Shortcuts
          </h2>
          <p className="text-gray-500 text-xl max-w-xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
            From the first nail to the final walkthrough — we own every detail.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service) => (
            <div
              key={service.title}
              className="group bg-white border border-gray-100 rounded-xl p-7 flex flex-col items-start transition-all duration-300 hover:-translate-y-1 hover:border-red-200 hover:bg-red-50/30 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-xl mb-4 group-hover:bg-red-200 transition-colors">
                <i className={`${service.icon} text-red-700 text-xl`} />
              </div>
              <h3 className="text-lg font-black text-gray-900 mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>
                {service.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed flex-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                {service.description}
              </p>
              <button
                onClick={handleScroll}
                className="mt-5 inline-flex items-center gap-2 text-red-700 font-semibold text-sm hover:text-red-800 transition-colors cursor-pointer whitespace-nowrap group-hover:gap-3"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Start Your Solution
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
